// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADMINCLUB_MENU = "Adminclub";
export const DELETE = "Zma\u017e";
export const GROUP_EDIT = "Uprav popis a fotku";
export const GROUP_REPORTED_POSTS = "Nahl\u00e1sen\u00e9 pr\u00edspevky";
